<template>
  <el-container class="h-100 w-100 bg-ff">
    <el-aside width="200px">
      <div class="title border-b-e2">工程进度管理</div>
      <div class="menu">
        <div v-if="permission.includes('progressTemplete')" class="bg-f3f4f7 ptb-20"><button class="btn-30-border-30313a-small mlr-20 text-left" @click="templateShow">选择工程进度模板<i class="el-icon-arrow-right ml-10"></i></button></div>
            <div v-if="modelList.length>0" class="bg-ff">
              <div v-for="(item,index) in modelList" :key="index" @click="selectBtn(index, item)">
                <div class="ptb-12 plr-20 border-b-dashed-e2 text-left"  v-if="index === selectedIndex" style="background: #f5971d">
              <div class="font-12-ff">计划时间：</div>
              <div class="font-12-ff">{{Utils.formatDate(item.planStartTime)}} ~ {{Utils.formatDate(item.planEndTime)}}</div>
              <div class="font-14-ff mt-10">{{item.name}}</div>
              <div class="flex flex-wrap">
                <div class="btn-16-bd-ff-r mt-10 mr-5" v-if="item.waitCheck === 1">待验收</div>
                <div class="btn-16-bd-ff-r mt-10 mr-5" v-if="item.check">已验收</div>
                <div class="btn-16-bd-ff-r mt-10 mr-5" v-if="item.delay">已延期</div>
                <div class="btn-16-bd-ff-r mt-10" v-if="item.conduct">进行中</div>
              </div>
            </div>
            <div class="ptb-12 plr-20 border-b-dashed-e2 text-left" v-else>
              <div class="font-12-b9b9b9">计划时间：</div>
              <div class="font-12-b9b9b9">{{Utils.formatDate(item.planStartTime)}} ~ {{Utils.formatDate(item.planEndTime)}}</div>
              <div class="font-14-30313a mt-10">{{item.name}}</div>
              <div class="flex flex-wrap">
                <div class="btn-16-bg-f3f4f7-r mt-10 mr-5" v-if="item.waitCheck === 1">待验收</div>
                <div class="btn-16-bg-82b925-r mt-10 mr-5" v-if="item.check">已验收</div>
                <div class="btn-16-bg-ff5555-r mt-10 mr-5" v-if="item.delay">已延期</div>
                <div class="btn-16-bd-85-r mt-10" v-if="item.conduct">进行中</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-aside>
    <el-main class="flex-column">
      <div class="customerInfo flex align-center justify-space-between">
        <div class="flex align-center">
          <div>
            <div><span>客户信息：</span>{{info.name}}</div>
            <div><span>装修地址：</span>{{info.detailedAddress}}</div>
          </div>
          <div class="line"></div>
          <div>
            <div><span>项目经理：</span>{{customerAssign.pmName}}</div>
            <div><span>工程监理：</span>{{customerAssign.suName}}</div>
          </div>
          <div class="line"></div>
          <div>
            <div><span>计划完工：</span>{{info.contractFinishTime ? Utils.formatDate(info.contractFinishTime) : '-'}}</div>
            <div style="opacity: 0"><span>计划开工：</span>-</div>
          </div>
          <div class="line"></div>
          <div>
            <div><span>实际开工：</span>{{info.actualStartTime ? Utils.formatDate(info.actualStartTime) : '-'}}</div>
            <div><span>实际完工：</span>{{info.actualEndTime ? Utils.formatDate(info.actualEndTime) : '-'}}</div>
          </div>
          <div class="line"></div>
          <div>
            <div class="font-12-ff5555 font-bold">{{totalOverdue >= 0 ? '总延期': '总提前'}}</div>
            <div class="btn-16-bg-ff5555-r">{{totalOverdue >= 0 ? totalOverdue : totalOverdue*-1}}天</div>
          </div>

        </div>
        <div class="close flex align-center justify-center cursor" @click="onClose">
          <i class="el-icon-close font-18-ff"></i>
        </div>
      </div>
      <div class="content flex-column flex-1 bg-f3f4f7">
        <div class="bg-ff flex-1" v-if="modelList.length>0">
          <div class="flex mb-10 plr-20 border-b-e2 align-center">
            <div class="title flex align-center mr-20">
              <div class="decoration-line mr-5"></div>
              <div class="font-16-f5971d font-bold">{{nowTemplate.name}}</div>
            </div>
            <div class="date flex  align-center mtb-5 mr-20">
              <div class="font-12-30313a">计划时间：</div>
              <el-date-picker
                v-model="planStartTime"
                type="date"
                @change="selectTime(planStartTime,'planStartTime')"
                :disabled = "modelList[selectedIndex].check ? true : false"
                placeholder="计划开始时间"
                value-format="yyyy-MM-dd">
              </el-date-picker>
              <span class="font-12-b9b9b9" style="width: 24px;border: 1px solid #e2e2e2;height: 30px; line-height: 30px;">至</span>
              <el-date-picker
                  v-model="planEndTime"
                  @change="selectTime(planEndTime,'planEndTime')"
                  :disabled = "modelList[selectedIndex].check ? true : false"
                type="date"
                placeholder="计划结束时间"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
            <div class="date flex  align-center mtb-5">
              <div class="font-12-30313a">实际时间：</div>
              <el-date-picker
                v-model="actualStartTime"
                @change="selectTime(actualStartTime,'actualStartTime')"
                type="date"
                :readonly="permission.includes('progressBasic') || permission.includes('progressCheck') ? false : true"
                :disabled = "modelList[selectedIndex].check ? true : false"
                placeholder="实际开始时间"
                value-format="yyyy-MM-dd">
              </el-date-picker>
              <span class="font-12-b9b9b9" style="width: 24px;border: 1px solid #e2e2e2;height: 30px; line-height: 30px;">至</span>
              <el-date-picker
                v-model="actualEndTime"
                @change="selectTime(actualEndTime,'actualEndTime')"
                type="date"
                :readonly="permission.includes('progressBasic') || permission.includes('progressCheck') ? false : true"
                :disabled = "modelList[selectedIndex].check ? true : false"
                placeholder="实际结束时间"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
            <div class="btn-30-bg-f3f4f7 font-12-30313a ml-5 font-bold">工期<span class="font-12-b9b9b9">-</span>{{nowTemplate.period}}天</div>
            <div class="btn-30-bg-f3f4f7 font-12-ff5555 ml-5 font-bold">{{nowTemplate.overdue >= 0 ? '延期' : '提前'}}<span class="font-12-b9b9b9">-</span>{{nowTemplate.overdue > 0 ? nowTemplate.overdue : (nowTemplate.overdue)*-1}}天</div>
            <div class="flex flex-1 justify-end" v-if="!modelList[selectedIndex].check && permission.includes('progressCheck')"><button class="flex btn-30-bg-82b925-big" @click="check">立即验收</button></div>
          </div>
          <div class="mtb-10 flex flex-wrap plr-20" v-if="!modelList[selectedIndex].check">
            <div class="flex align-center mr-5 mb-5 " v-if="permission.includes('progressBasic')" :class="0 === Index ? 'btn-24-bg-f5971d' : 'btn-24-bd-30313a' " @mouseenter="enter(2)" @mouseleave="leave(2)"  @click="checkType('上传图片')">
              <img :src="0 === Index ? '/static/images/customer/chubeikehu-bai.png' : '/static/images/customer/chubeikehu.png'" class="icon-14 mr-5" alt="">
              <el-upload
                multiple
                name="file"
                :httpRequest="httpRequestImg"
                :action="upload"
                :show-file-list="false"
                :before-upload="beforeImgUpload">
                <div>上传照片</div>
              </el-upload>
            </div>
            <div class="flex align-center mr-5 mb-5 " v-if="permission.includes('progressCheck')" :class="index === Index ? 'btn-24-bg-f5971d' : 'btn-24-bd-30313a' " @mouseenter="enter(index)" @mouseleave="leave(index)" v-for="(item, index) in btnList" :key="index" @click="checkType(item.name)">
              <img :src="index === Index ? item.iconActive : item.icon" class="icon-14 mr-5" alt="">
              <div>{{item.name}}</div>
            </div>
            <div class="btn-24-bd-30313a font-12-30313a flex align-center" @click="changeResult">整改结果<i class="el-icon-arrow-right ml-5"></i></div>
          </div>
          <div class="flex flex-wrap plr-20" v-if="picList.length>0">
            <div class="mr-10 mb-10 bg-f3f4f7" v-for="(item,index) in picList" :key="index">
              <div class="p-relative">
                <viewer :images="picList">
                <img :src="item.status=== 3 ? item.rectificationPath:item.path" class="img-206" alt="" style="display:block">
                </viewer>
                <div class="p-absolute qualified" v-if="item.status === 2"><img src="/static/images/customer/hege.png" alt=""></div>
                <!--<div class="p-absolute rectification font-12-30313a" v-if="item.status === 3">整改结果<i class="el-icon-arrow-right ml-5"></i></div>-->
                <div class="p-absolute unqualified" v-if="item.status === -1"><img src="/static/images/customer/buhege.png" alt=""></div>
                <div class="p-absolute flex newImg align-center">
                  <div class="flex-1 text-left" v-if="(item.status === 3 || item.status ===1) && !modelList[selectedIndex].check" @click="seletedPic(index, item.id)"><img :src=" item.selected ? '/static/images/customer/xuanze-bai.png' : '/static/images/customer/xuanze-hui.png'" alt=""></div>
                  <!--<div class="flex-1" v-if="item.status === 3"><span class="imgMark font-12-ff">整改图片</span></div>-->
                  <div class="flex flex-1 justify-end" v-if="(item.status === 3 || item.status ===1) && !modelList[selectedIndex].check" @click="deletePic(item.id)"><img src="/static/images/customer/shanchu.png" alt=""></div>
                </div>
                <div class="p-absolute location flex align-center"><img src="/static/images/customer/dingwei.png" class="icon-10-12 ml-5" alt=""><span class="text-nowrap font-12-ff ml-5">{{item.address ? item.address : '暂无详细地址信息'}}</span></div>
              </div>
              <div class="border-e2 border-ra m-10 h-30 plr-10 font-12-30313a flex align-center" v-if="modelList[selectedIndex].check || item.status === 2">{{item.standardName ? item.standardName : '暂无'}}</div>
              <el-select @focus="beforeSelect(item.id)" placeholder="请选择"  @change="selectTrigger"  v-model="item.standardName"  class=" m-10 h-30" v-else>
                <el-option :label="option.name"  :value="option.id+','+option.name" v-for="(option,idx) in nowTemplate.progressStandardTemplateList" :key="idx"></el-option>
              </el-select>
              <div class="font-12-b9b9b9 mlr-10" :class="item.auditorName? '': 'mb-10'" v-if="item.uploaderName">上传 <span class="ml-10">{{item.uploaderName}} {{Utils.formatTime2(item.createTime)}}</span></div>
              <div class="font-12-b9b9b9 mlr-10 mb-10" v-if="item.auditorName">审核 <span class="ml-10">{{item.auditorName}} {{Utils.formatTime2(item.auditTime)}}</span></div>
            </div>
          </div>
        </div>
        <el-main v-else class="flex align-center justify-center">
          <div class="text-center">
            <div class="flex justify-center"><img src="/static/images/tip.png" class="icon-50 mb-20" alt=""></div>
            <div class="font-12-ff5555">注意：此客户还未添加工程进度模板！</div>
            <div class="font-12-ff5555">请点击左上角“选择工程进度模板”按钮进行添加</div>
          </div>
        </el-main>
      </div>
    </el-main>
    <el-dialog title="选择工程进度模板" :visible.sync="modelVisible" class="handlePlan" style="min-width: 357px">
      <div class="p-20">
        <div class="flex text-left mb-10" :class="index === temIndex ? 'btn-50-bg-f5971d' : 'btn-50-bg-f3f4f7'" v-for="(item,index) in templateList" :key="index" @mouseenter="enter1(index)" @mouseleave="leave1(index)"  @click="selectTem(item)" >
          <div class="" style="font-size: 24px;">{{item.name}}</div>
          <div class=" flex-1 justify-end text-right">标准工程进度模板<i class="el-icon-arrow-right"></i></div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="templateVisible" width="85%" class="handlePlan">
      <div class="p-20">
        <div class="flex-1" style="height:360px">
          <erp-table :is-edit="true" ref="erpTable" @on-modify="onModifyRow" modify-method="on-modify" :table-data="tableData1"  :loading="loading" :column-data="columnData1"></erp-table>
        </div>
      </div>
      <div slot="footer">
      <div class="btn-30-bd-85-s mr-10" @click="reset">重置</div>
      <div class="btn-30-bg-f5971d-s" @click="onSubmit">确定</div>
      </div>
    </el-dialog>
    <el-dialog title="整改通知单" :visible.sync="changeNotice" width="526px" class="handlePlan" @close="onCloseNotice" v-if="nowTemplate">
      <div class="p-20">
        <div class="flex">
          <img src="/static/images/jinggao.png" class="icon-14 mr-5" alt="">
          <div class="font-12-30313a">整改提示：<span class="font-12-ff5555">{{nowTemplate.name}}</span>中本次有<span class="font-12-ff5555">{{arrt.length}}张</span>照片不合格，未通过需进行整改：</div>
        </div>
        <div class="flex flex-wrap">
          <viewer :images="picList" class="bg-f3f4f7 w-114 mt-10 mr-10" v-for="(item,index) in picList" :key="index" v-if="item.selected">
            <img :src="item.path" alt="">
            <div class="p-10">{{item.standardName ? item.standardName : '暂无'}}</div>
          </viewer>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-bg-f5971d-s">发送给项目经理及监理</div>
      </div>
    </el-dialog>
    <el-dialog title="整改结果" :visible.sync="changeResults" width="526px" v-if="nowTemplate">
      <div class="p-20 flex-cloum">
        <div class="flex">
          <div><img src="/static/images/jinggao.png" class="icon-14 mr-5" alt=""></div>
          <div class="font-12-30313a"><span class="font-12-ff5555">{{nowTemplate.name}}</span>中的<span class="font-12-ff5555">{{changedPic.length}}张</span>不合格照片已进行整改</div>
        </div>
        <div style="max-height: 580px;overflow-y: auto;" v-if="changedPic.length>0">
          <div class="mt-20 flex"  v-for="(item,index) in changedPic" :key="index">
            <div class="bg-f3f4f7 w-206 mt-10" >
              <viewer :images="changedPic">
              <img :src="item.path" class="changeResult" alt="">
              </viewer>
              <div class="p-10 flex">{{item.standardName ? item.standardName : '暂无'}}</div>
            </div>
            <div class="flex justify-center align-center" style="width: 74px;"><img src="/static/images/zhenggaihou.png" alt=""></div>
            <div class="bg-f3f4f7 w-206 mt-10 p-relative">
              <div class="p-absolute changeStatus flex justify-center" v-if="item.isHandled !== 1">
                <div class="btn-24-bg-ff mr-20" @click="changeJudge(2, item)">合格</div>
                <div class="btn-24-bg-ff" @click="changeJudge(-1, item)">不合格</div>
              </div>
              <viewer :images="changedPic">
                <img :src="item.rectificationPath" class="changeResult" alt="">
              </viewer>
              <div class="p-10 flex">{{item.name ? item.name : '暂无'}}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import ErpTable from '../../components/ErpTable'
export default {
  name: 'projectProgress',
  components: {ErpTable},
  data () {
    return {
      permission: [],
      selectArry: [],
      id: null,
      info: {},
      upload: `${this.$store.state.API_URL_9009}/fileUpload/uploadFile`,
      totalOverdue: null,
      customerAssign: {},
      progressList: [],
      selectedIndex: 0,
      nowTemplate: {},
      hasProgress: true,
      modelVisible: false,
      templateVisible: false,
      changeResults: false,
      changeNotice: false,
      templateList: [],
      title: '',
      selectTemplate: {},
      planStartTime: '',
      planEndTime: '',
      actualStartTime: '',
      actualEndTime: '',
      Index: -1,
      modelList: [],
      temIndex: -1,
      unqualifiedAmount: 0,
      btnList: [
        {
          name: '合格',
          btnClick: 'qualified',
          icon: '/static/images/customer/hege01.png',
          iconActive: '/static/images/customer/hege01-bai.png'
        },
        {
          name: '不合格',
          btnClick: 'unqualified',
          icon: '/static/images/customer/bufuhe.png',
          iconActive: '/static/images/customer/bufuhe-bai.png'
        }
      ],
      selected: false,
      picList: [],
      columnData1: [{
        type: 'index',
        title: '序号',
        width: '60',
        fixed: 'left'
      }, {
        field: 'name',
        title: '进度名称',
        width: '300'
      }, {
        field: 'startTime',
        title: '计划开始时间',
        width: '200',
        editType: 'date', // 为日期的编辑
        dateConfig: { // 为日期时必填  用来区分是日期还是日期+时间
          format: 'yyyy-MM-dd',
          type: 'date', // 显示类型 year/month/date/dates/ week/datetime/datetimerange/ daterange/monthrange  默认date
          valueFormat: 'timestamp' // yyyy-MM-dd/timestamp 参照https://element.eleme.cn/#/zh-CN/components/date-picker#ri-qi-ge-shi
        },
        editRender: {
          name: 'input'
        },
        formatter: ['toDateString', 'yyyy-MM-dd']
      }, {
        field: 'endTime',
        title: '计划结束时间',
        width: '200',
        editType: 'date', // 为日期的编辑
        dateConfig: { // 为日期时必填  用来区分是日期还是日期+时间
          format: 'yyyy-MM-dd',
          type: 'date', // 显示类型 year/month/date/dates/ week/datetime/datetimerange/ daterange/monthrange  默认date
          valueFormat: 'timestamp' // yyyy-MM-dd/timestamp 参照https://element.eleme.cn/#/zh-CN/components/date-picker#ri-qi-ge-shi
        },
        editRender: {
          name: 'input'
        },
        formatter: ['toDateString', 'yyyy-MM-dd']
      }, {
        field: 'remark',
        title: '备注',
        width: 'auto'
      }],
      tableData1: [],
      loading: true,
      arrt: [],
      changedPic: [],
      hasTemplate: false,
      currentPicId: '',
      selectItem: {}
    }
  },
  created () {},
  mounted () {
    this.id = this.$route.query.id
    this.getInfo()
    this.getPermission()
  },
  methods: {
    getPermission () {
      let list = {
        parent: 'projectProgress',
        parentGroup: 'projectProgress'
      }
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, list).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
    },
    selectTime (value, type) {
      let data = {}
      data[type] = value || -1
      data['id'] = this.nowTemplate.id
      this.axios.post(`${this.$store.state.API_URL_9010}/progressDetail/modify`, data).then(res => {
        if (res.data.success) {
          this.getTemplate()
        }
      })
    },
    beforeSelect (id) {
      this.currentPicId = id
    },
    selectTrigger (standard) {
      standard = standard + ''
      standard = standard.split(',')
      let standardId = standard[0]
      let standardName = standard[1]
      this.axios.post(`${this.$store.state.API_URL_9010}/progressPhoto/modify`, {
        id: this.currentPicId,
        standardId: standardId,
        standardName: standardName
      }).then(res => {
        if (res.data.success) {
          this.getPicList()
        }
      })
    },
    onModifyRow (row, column, colName) {
    },
    getInfo () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customer/getById`, this.qs.stringify({
        id: this.id
      })).then(res => {
        if (res.data.success) {
          this.info = res.data.data
          this.totalOverdue = res.data.data.totalOverdue
          this.customerAssign = res.data.data.customerAssign
          this.getTemplate()
        }
      })
    },
    selectBtn (a, item) {
      this.selectedIndex = a
      this.selectItem = item
      this.getTemplate()
    },
    templateShow () {
      if (this.modelList.length > 0) {
        this.$confirm('注意：您将要替换当前的工程进度模板，替换后之前进度数据及照片将被清除，切不能回复！是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.post(`${this.$store.state.API_URL_9010}/progressTemplate/list`, {
            isEnable: 1,
            companyId: this.$store.state.companyId
          }).then(res => {
            if (res.data.success) {
              this.templateList = res.data.data
              this.modelVisible = true
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消替换'
          })
        })
      } else {
        this.axios.post(`${this.$store.state.API_URL_9010}/progressTemplate/list`, {
          isEnable: 1,
          companyId: this.$store.state.companyId
        }).then(res => {
          if (res.data.success) {
            this.templateList = res.data.data
            this.modelVisible = true
          }
        })
      }
    },
    selectTem (e) {
      this.modelVisible = false
      this.templateVisible = true
      this.selectTemplate = e
      this.title = this.selectTemplate.name
      this.axios.post(`${this.$store.state.API_URL_9010}/progressDetailTemplate/list`, {
        progressId: this.selectTemplate.id
      }).then(res => {
        if (res.data.success) {
          this.loading = false
          this.tableData1 = res.data.data
        }
      })
    },
    onSubmit () {
      this.templateVisible = false
      let progressDetail = []
      let formData = new FormData()
      for (let i = 0; i < this.tableData1.length; i++) {
        let parameter = {}
        parameter.templateId = this.tableData1[i].id
        parameter.customerId = this.info.id
        parameter.name = this.tableData1[i].name
        parameter.planStartTime = this.tableData1[i].startTime
        parameter.planEndTime = this.tableData1[i].endTime
        parameter.remark = this.tableData1[i].remark
        progressDetail.push(parameter)
      }
      formData.append('description', '')
      this.axios.post(`${this.$store.state.API_URL_9010}/progressDetail/save`, progressDetail).then(res => {
        if (res.data.success) {
          this.getTemplate()
        }
      })
    },
    getTemplate () {
      this.axios.post(`${this.$store.state.API_URL_9010}/progressDetail/list`, {
        customerId: this.info.id
      }).then(res => {
        if (res.data.success) {
          this.modelList = res.data.data.list
          this.selectArry = this.modelList[this.selectedIndex].progressStandardTemplateList
          this.nowTemplate = res.data.data.list[this.selectedIndex]
          if (this.nowTemplate) {
            this.planStartTime = this.Utils.formatDate(this.nowTemplate.planStartTime)
            this.planEndTime = this.Utils.formatDate(this.nowTemplate.planEndTime)
            this.actualStartTime = this.Utils.formatDate(this.nowTemplate.actualStartTime)
            this.actualEndTime = this.Utils.formatDate(this.nowTemplate.actualEndTime)
            this.getPicList()
          }
        }
      })
    },
    // 图片列表
    getPicList () {
      this.axios.post(`${this.$store.state.API_URL_9010}/progressPhoto/list`, {
        detailId: this.nowTemplate.id
      }).then(res => {
        if (res.data.success) {
          for (let i in res.data.data) {
            res.data.data[i].selected = false
          }
          this.picList = res.data.data
        }
      })
    },
    seletedPic (index, id) {
      if (this.picList[index].selected === true) {
        this.picList[index].selected = false
        for (let j = 0; j < this.arrt.length; j++) {
          if (this.arrt[j] === id) {
            this.arrt.splice(j, 1)
          }
        }
      } else {
        this.picList[index].selected = true
        this.arrt.push(id)
      }
    },
    onCloseNotice () {
      this.arrt = []
      this.changeNotice = false
      this.getPicList()
    },
    checkPic (status) {
      if (this.arrt.length === 0) {
        this.$message.warning('请先选择要设置的照片！')
        return
      }
      this.axios.post(`${this.$store.state.API_URL_9010}/progressPhoto/audit`, {
        ids: this.arrt.join(','),
        status: status
      }).then(res => {
        if (res.data.success) {
          this.$message({
            type: 'success',
            message: '设置成功！'
          })
          if (status === -1) {
            this.changeNotice = true
          } else {
            this.getPicList()
            this.arrt = []
          }
        } else {
          this.$message.error('失败！')
        }
      })
    },
    changeResult () {
      this.changeResults = true
      this.axios.post(`${this.$store.state.API_URL_9010}/progressPhoto/list`, {
        detailId: this.nowTemplate.id,
        status: -1
      }).then(res => {
        if (res.data.success) {
          this.changedPic = res.data.data
        }
      })
    },
    changeJudge (status, item) {
      this.axios.post(`${this.$store.state.API_URL_9010}/progressPhoto/save`, {
        detailId: this.nowTemplate.id,
        sourceId: item.id,
        path: item.rectificationPath,
        status: status
      }).then(res => {
        if (res.data.success) {
          this.$message({
            type: 'success',
            message: '审核成功！'
          })
          this.changeResults = false
          this.getPicList()
        }
      })
    },
    deletePic (id) {
      this.axios.post(`${this.$store.state.API_URL_9010}/progressPhoto/deleteById`, this.qs.stringify({
        id: id
      })).then(res => {
        if (res.data.success) {
          this.$message({
            type: 'success',
            message: '删除成功！'
          })
          this.getPicList()
        }
      })
    },
    reset () {
      this.axios.post(`${this.$store.state.API_URL_9010}/progressDetailTemplate/list`, {
        progressId: this.selectTemplate.id
      }).then(res => {
        if (res.data.success) {
          this.loading = false
          this.tableData1 = res.data.data
        }
      })
    },
    onClose () {
      this.$router.go(-1)
    },
    enter (a) {
      this.Index = a
    },
    leave () {
      this.Index = -2
    },
    enter1 (a) {
      this.temIndex = a
    },
    leave1 () {
      this.temIndex = -1
    },
    photoSelect () {
      this.selected = !this.selected
    },
    beforeImgUpload () {},
    httpRequestImg (e) {
      let formData = new FormData()
      formData.append('fileData', e.file)
      formData.append('type', 4)
      formData.append('description', '')
      this.axios.post(`${this.$store.state.API_URL_9009}/fileUpload/uploadFile`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        if (onloadRes.data.success) {
          this.axios.post(`${this.$store.state.API_URL_9010}/progressPhoto/save`, {
            path: onloadRes.data.data.path,
            detailId: this.nowTemplate.id
          }).then(saveRes => {
            if (saveRes.data.success) {
              this.getPicList()
              this.$message({
                type: 'success',
                message: '上传成功！'
              })
            } else {
              this.$message.error('上传失败！')
            }
          })
        }
      }).catch(() => {
        this.$message.error('上传失败！')
      })
    },
    checkType (name) {
      let that = this
      if (name === '上传图片') {
      }
      if (name === '合格') {
        let status = 2
        that.checkPic(status)
      }
      if (name === '不合格') {
        this.checkPic(-1)
        // this.changeNotice = true
        // setTimeout(function () {
        //   this.changeNotice = false
        // }, 1000)
      }
    },
    check () {
      this.axios.post(`${this.$store.state.API_URL_9010}/progressDetail/check`, {
        id: this.nowTemplate.id
      }).then(saveRes => {
        if (saveRes.data.success) {
          this.getTemplate()
          this.$message({
            type: 'success',
            message: '验收成功！'
          })
        } else {
          this.$message.error('验收失败！')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-aside{
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    position: relative;
  }
  .el-main{
    padding: 0;
  }
  .aside-top{
    height: 5px;
    background: #f5971d;
    width: 100%;
  }
  .el-aside .title{
    background: #ffffff;
    height: 50px;
    line-height: 50px;
    text-align: left;
    font-weight: bold;
    font-size: 18px;
    color: #30313a;
    padding-left: 20px;
  }
  .customerInfo{
    width: 100%;
    height: 50px;
    /*background: #fff;*/
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    font-size: 12px;
    color: #30313a;
    text-align: left;
    padding-left:20px;
    position: relative;
  }
  .close{
    width: 50px;
    height: 50px;
    background: #ff5555;
  }
  .customerInfo span{
    color: #b9b9b9;
  }
  .line{
    height: 32px;
    background: #f3f4f7;
    width: 1px;
    margin: 0 20px;
  }
  .hr{
    width: 100%;
    height: 1px;
    background: #e2e2e2;
    margin: 10px 0;
  }
  .hr-dashed{
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #e2e2e2;
    margin: 12px 0;
  }
  .content{
    padding: 10px 20px;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .img-206{
    width: 206px;
    height: 206px;
    object-fit: cover;
  }
  .qualified{
    top: 0;
    right: 10px;
    width: 15px;
    height: 36px;
  }
  .qualified >img{
    width: 100%;
    height: 100%;
  }
  .unqualified{
    top: 0;
    right: 0;
    width: 49px;
    height: 46px;
  }
  .unqualified>img{
    width: 100%;
    height: 100%;
  }
  .location{
    left: 10px;
    right: 10px;
    bottom: 0;
    height: 20px;
    background: rgba(0,0,0,.2);
    border-radius: 4px;
  }
  .changeStatus {
    left: 10px;
    right: 10px;
    top: 10px;
    height: 20px;
  }
  .text-nowrap{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .rectification{
    top: 10px;
    left: 10px;
    border-radius: 3px;
    height: 24px;
    background: #ffffff;
    padding: 0 10px;
    line-height: 24px;
  }
  .newImg{
    top: 10px;
    left: 10px;
    right: 10px;
  }
  .imgMark{
    height: 20px;
    background: rgba(0,0,0,.15);
    border-radius: 15px;
    padding: 0 6px;
  }
  .date /deep/ .el-input__icon{
    color: #30313a;
  }
  .btn-50-bg-f3f4f7{
    height: 50px;
    align-items: center;
    background: #f3f4f7;
    border: 1px solid #e2e2e2;
    padding: 0 20px;
    border-radius: 3px;
    color: #30313a;
    font-size: 12px;
    z-index: 22;
  }
  .btn-50-bg-f5971d{
    height: 50px;
    align-items: center;
    background: #f5971d;
    border: 1px solid #e2e2e2;
    padding: 0 20px;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
  }
  .w-114{
    width: 114px;
  }
  .w-114 img{
    width: 114px;
    height: 114px;
    object-fit: cover;
  }
  .changeResult{
    width: 206px;
    height: 206px;
    object-fit: cover;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/projectProgress.vue